import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';
import { persistState } from '@datorama/akita';
import { debounceTime } from 'rxjs/operators';


const storage = persistState({
  include: ['UI/vehicle', 'globalState'],
  preStorageUpdateOperator: () => debounceTime(2000),
});

const providers = [{ provide: 'persistStorage', useValue: storage }];

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic(providers)
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));

if (environment.useSentry) {
  Sentry.init({
    dsn: environment.sentryDSN,
    autoSessionTracking: true,
    denyUrls: [
      environment.baseWSUrl, // we ignore websocket errors
    ]
  });
}

